/*
 * CongregationList Messages
 *
 * This contains all the text for the CongregationList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.CongregationList.title',
    defaultMessage: 'Congregation Management',
  },
  name: {
    id: 'app.containers.CongregationList.description',
    defaultMessage: 'Circuit {circuit}',
  },
  noCongregationsYet: {
    id: 'app.containers.CongregationList.noCongregationsYet',
    defaultMessage: 'There are no congregations, yet.',
  },
});
